import { render, staticRenderFns } from "./UpdateState.vue?vue&type=template&id=2a9b385a&scoped=true&"
import script from "./UpdateState.vue?vue&type=script&lang=ts&"
export * from "./UpdateState.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateState.vue?vue&type=style&index=0&id=2a9b385a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b385a",
  null
  
)

export default component.exports